import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_sra'

export default {
  key: 'security_managment_sra',
  label: 'GSMS - SRA',
  timeColumn: 'security_managment_sra.fso_training_date_completed',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_sra: ["id", "id_security_managment_risk_assessment", "building_code", "most_recent_sra", "question_page", "question_category", "question_topic", "question_text", "plain_text_value", "plain_text_value_ext1", "description_of_gap", "impacts_residual_risk", "corrective_action", "new_exception_requested", "icaps_number", "created_by", "created_on", "last_updated_by", "last_updated_on", "created_at", "updated_at"],
    security_managment_facility: ["id", "facility_id", "csis_building_status", "crs_building_status", "region", "country", "state", "city", "zip", "address", "building_code", "facility_name", "floor_code", "occupied", "has_data_center", "has_child_care", "number_of_floors", "occupied_floors", "owned_or_leased", "vacancy_date", "headcount", "updated_headcount", "primary_facility_type", "source_instance", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'security_managment_sra',
    columns: 'security_managment_facility.building_code,security_managment_facility.facility_name,security_managment_facility.address,security_managment_facility.city,security_managment_facility.state,security_managment_facility.country,security_managment_facility.primary_facility_type,security_managment_facility.csis_building_status',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_facility.building_code', label: 'Instalacion' },
    { key: 'security_managment_facility.facility_name', label: 'Nombre instalacion' },
    { key: 'security_managment_facility.address', label: 'Direccion' },
    { key: 'security_managment_facility.city', label: 'Ciudad' },
    { key: 'security_managment_facility.state', label: 'Estado' },
    { key: 'security_managment_facility.country', label: 'Pais' },
    { key: 'security_managment_sra.most_recent_sra', label: 'Estatus' },
    { key: 'security_managment_sra.question_text', label: 'Pregunta' },
    { key: 'security_managment_sra.question_page', label: 'Pagina' },
    { key: 'security_managment_sra.created_by', label: 'Referencia' },
    { key: 'security_managment_sra.question_category', label: 'Tipo' },
    { key: 'security_managment_sra.question_topic', label: 'Nivel' },
    { key: 'security_managment_sra.fso_training_date_completed', label: 'Fecha', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_facility.building_code', 'Instalacion', 'installation'),
    embedFilter(DATASET_KEY, 'security_managment_facility.facility_name', 'Nombre instalacion', 'facility_name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.city', 'Ciudad', 'city'),
    embedFilter(DATASET_KEY, 'security_managment_facility.state', 'Estado', 'state'),
    embedFilter(DATASET_KEY, 'security_managment_facility.country', 'Pais', 'country'),
    embedFilter(DATASET_KEY, 'security_managment_sra.most_recent_sra', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'security_managment_sra.question_text', 'Pregunta', 'name'),
    embedFilter(DATASET_KEY, 'security_managment_sra.question_page', 'Pagina', 'group'),
    embedFilter(DATASET_KEY, 'security_managment_sra.created_by', 'Referencia', 'reference'),
    embedFilter(DATASET_KEY, 'security_managment_sra.question_category', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'security_managment_sra.question_topic', 'Nivel', 'level'),
  ],

    dateGrouping: {
    column: 'security_managment_sra.fso_training_date_completed',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
